var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.555v11.87c0 4.75-1 5.936-5 5.936H6c-4 0-5-1.187-5-5.935V7.555c0-4.748 1-5.936 5-5.936h6c4 0 5 1.188 5 5.936zM11 5.774H7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 20.079c0 .364-.09.72-.261 1.022-.17.303-.412.539-.696.678-.283.14-.595.175-.895.105a1.493 1.493 0 01-.794-.504 1.968 1.968 0 01-.424-.942c-.06-.357-.03-.727.088-1.063.118-.337.316-.624.571-.826.255-.202.555-.31.861-.31.411 0 .806.194 1.096.539.29.345.454.813.454 1.3v0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/Mobile.85e65b2f.svg";
export { SvgMobile as ReactComponent };